const TURBO_STREAM_TYPE = "text/vnd.turbo-stream.html"
const SIGN_IN_PATH = "/users/sign_in"

export function validMultiTargetStreamResponse(response, body, expectedStreams) {
  if (!response.headers.get("Content-Type")?.toLowerCase().startsWith(TURBO_STREAM_TYPE)) return false

  const expectedByTarget = new Map(expectedStreams.map((expected) => [ expected.target, expected ]))
  if (expectedByTarget.size !== expectedStreams.length) return false

  const parsed = new DOMParser().parseFromString(body, "text/html")
  const meaningful = Array.from(parsed.body.childNodes).filter((node) => {
    if (node.nodeType === Node.COMMENT_NODE) return false
    return node.nodeType !== Node.TEXT_NODE || node.textContent.trim() !== ""
  })
  if (meaningful.length !== expectedStreams.length || meaningful.some((node) => node.nodeType !== Node.ELEMENT_NODE)) {
    return false
  }

  const targets = meaningful.map((stream) => stream.getAttribute("target"))
  if (new Set(targets).size !== expectedStreams.length) return false

  return meaningful.every((stream) => {
    const expected = expectedByTarget.get(stream.getAttribute("target"))
    if (!expected || stream.tagName !== "TURBO-STREAM") return false
    if (stream.getAttribute("action") !== expected.action) return false
    if (expected.method !== undefined && stream.getAttribute("method") !== expected.method) return false

    const directElements = Array.from(stream.children)
    if (directElements.length !== 1 || directElements[0].tagName !== "TEMPLATE") return false

    return document.querySelectorAll(`#${CSS.escape(expected.target)}`).length === 1
  })
}

export function signInResponse(response) {
  const responseUrl = new URL(response.url, window.location.origin)
  const mediaType = response.headers.get("Content-Type")?.toLowerCase() || ""
  return responseUrl.origin === window.location.origin &&
    responseUrl.pathname === SIGN_IN_PATH && mediaType.startsWith("text/html")
}
